<template>
  <ModalDialog
    ref="dialog"
    title="New Stocktake"
    :submitting="submitting"
    submitTitle="Confirm"
    icon="fa-warehouse-alt"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm" :labelColumnSize="3">
      <FormRow label="Stocktake Name">
        <FormInputText v-model="stocktake.name" field="name" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

export default {
  name: 'StockTakeNewDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  data() {
    return {
      dialogForm: {},
      submitting: false,
      stocktake: {
        name: ''
      },
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show() {
      // Reset form
      this.stocktake = { name: '' }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var stocktakeData = this.stocktake

      this.$apiService.inventoryService.createStocktake(stocktakeData)
      .then(response => {
        this.modalClosed(response.data.id)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    }
  }
}
</script>